import { GlobalState } from 'src/redux/store';

export const industryStandardsSelector = (state: GlobalState) => state.industryStandards;

export const industryStandardsSelectorData = (state: GlobalState) =>
    industryStandardsSelector(state).data;

export const industryStandardsStatusSelector = (state: GlobalState) =>
    industryStandardsSelector(state).status;
